export default "__VITE_ASSET__CrhMzNM4__"